<template>
  <th class="text-left p-2">
    <slot />
  </th>
</template>